import SimpleModal from 'syf-component-library/ui/patterns/SimpleModal'
import query from 'mediaQueries'
import styled, { FlattenSimpleInterpolation, css } from 'styled-components'
import Button from 'syf-component-library/ui/atoms/Button'
import { colors } from 'const/colors'
import images from 'const/images'
import { formatTime } from 'helpers/fieldFormatters'
import { FA_TIMES } from 'const/icons'
import Icon from 'ui/atoms/Icon'
import { ReactElement } from 'react'

export const Container = styled.div`
  background-color: red;
  & > div:after {
    z-index: 4;
  }
`

export const SessionTimeOutModal = styled(SimpleModal)`
  top: 40%;
  width: 90%;
  min-width: 85%;
  border-radius: 6px;
  z-index: 10;
  @media ${query.greaterThanSmall} {
    min-width: 250px;
    width: 344px;
    height: 373px;
  }
`

const ContainerCSS = css`
  text-align: center;
  margin: 128px auto 0;
  max-width: 350px;
`

export const SessionExpiredContainer = styled.div<{ isExpired: boolean }>`
  ${({ isExpired }) => isExpired && ContainerCSS}
`

export const HeaderText = styled.h1`
  font-size: 24px;
  margin: 0;
`

export const SessionTimeOutContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 27px;
`

export const PrimaryText = styled.p`
  margin: 20px 0 7px;
`

export const SecondaryText = styled.p`
  margin: 8px 0 7px;
`

export const ContinueSessionButton = styled(Button)`
  width: 100%;
  margin: 26px 0;
  text-transform: uppercase;
`

export const LoginAgainButton = styled(Button)`
  width: 56%;
  margin: 26px 0;
  background-color: ${colors.white};
  text-transform: uppercase;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 92%;
`
const { alarm } = images

const LinearGradientCSS = (
  primary: string,
  isSessionExpired: boolean
): FlattenSimpleInterpolation => {
  return css`
  linear-gradient(${(!isSessionExpired && primary) || colors.darkCoral},${
    (!isSessionExpired && primary) || colors.error
  })
  `
}

const ContainerHeader = styled.div<TimeOutProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 115px;
  width: 100%;
  background-image: ${({ theme, isSessionExpired }: TimeOutProps) =>
    LinearGradientCSS(theme.primary, isSessionExpired)};
`

const SessionTimeLeftWrapper = styled.div`
  display: flex;
  align-items: center;
`

const Image = styled.img`
  height: 20px;
  width: 20px;
  margin: 0 6px 0;
`

const TimeLeft = styled.span`
  font-size: 24px;
  color: ${colors.white};
`

const SessionHeaderSecondaryText = styled.p`
  color: ${colors.greyTen};
  margin: 0;
`

const CloseIconContainer = styled.div`
  position: absolute;
  top: 12px;
  right: 15px;
`

const CloseIcon = styled(Icon)`
  font-size: 24px;
  color: ${colors.white};
  cursor: pointer;
`
interface SessionTimeOutHeaderProps {
  sessionHeaderRef?: React.Ref<HTMLHeadingElement>
  closeModal?: () => void
  timeLeft?: number
  isSessionExpired?: boolean
}

interface ColorProps {
  primary: string
}

interface TimeOutProps {
  isSessionExpired?: boolean
  theme?: ColorProps
}

export const SessionTimeOutHeader = ({
  sessionHeaderRef,
  closeModal,
  timeLeft,
  isSessionExpired
}: SessionTimeOutHeaderProps): ReactElement => {
  return (
    <ContainerHeader isSessionExpired={isSessionExpired}>
      <SessionTimeLeftWrapper
        id="sessionTimeOutModalTitle"
        ref={sessionHeaderRef}
      >
        <Image alt="" src={alarm} />
        <TimeLeft>{formatTime(timeLeft)} seconds</TimeLeft>
      </SessionTimeLeftWrapper>
      <SessionHeaderSecondaryText>
        {' '}
        remaining in your session
      </SessionHeaderSecondaryText>
      <CloseIconContainer onClick={closeModal} data-test="close-icon">
        <CloseIcon name={FA_TIMES} />
      </CloseIconContainer>
    </ContainerHeader>
  )
}
